<div class="non-certified-dialog">

  <!-- Header -->
  <div class="dialog-header">
    <div class="header-left">
      <span class="pi pi-check-circle header-icon"></span>
      <h2>Non-certified checksheet assignments</h2>
      <span class="result-count">{{ rowCount }} assignment{{ rowCount !== 1 ? 's' : '' }}</span>
    </div>
    <button pButton icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" (click)="close()" class="close-btn" aria-label="Close"></button>
  </div>

  <!-- Empty state -->
  @if ((data?.rows?.length || 0) === 0) {
    <div class="empty-state">
      <span class="pi pi-info-circle empty-icon"></span>
      <p>All checksheet assignments are included in certificates.</p>
      @if (data?.cpNumber) {
        <p class="cp-label">CP {{ data.cpNumber }}</p>
      }
    </div>
  }

  <!-- Table -->
  @if ((data?.rows?.length || 0) > 0) {
    <app-checksheet-assignments-table
      [assignments]="assignmentData"
      [displayColumns]="displayColumns"
      (navigate)="onAssignmentNavigation($event)"
    ></app-checksheet-assignments-table>
  }

  <!-- Footer -->
  <div class="dialog-footer">
    <button pButton label="Close" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="close()"></button>
  </div>

</div>
